exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableWrapper__loadingPlaceholder__3KEtD{position:relative}.tableWrapper__loadingPlaceholder__3KEtD .tableWrapper__text__3f982{color:#000!important;font-size:28px;line-height:34px;padding-top:25px;text-align:center;position:relative}.tableWrapper__loadingPlaceholder__3KEtD .tableWrapper__sub__7oxTF{display:block;font-size:1em;font-weight:400;text-transform:none}.tableWrapper__loadingPlaceholder__3KEtD .tableWrapper__fa__1wSQ7{font-family:FontAwesome!important;font-style:400;left:46.5%;position:absolute;top:0}.tableWrapper__loadingPlaceholder__3KEtD p{font-size:1.1em;line-height:1.5em;margin:1em auto 4em;width:50%;text-align:center}.tableWrapper__loadingPlaceholder__3KEtD .tableWrapper__loadingError__R2jkp{color:red}", ""]);

// exports
exports.locals = {
	"loadingPlaceholder": "tableWrapper__loadingPlaceholder__3KEtD",
	"text": "tableWrapper__text__3f982",
	"sub": "tableWrapper__sub__7oxTF",
	"fa": "tableWrapper__fa__1wSQ7",
	"loadingError": "tableWrapper__loadingError__R2jkp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/tableWrapper/tableWrapper.css
// module id = 750
// module chunks = 0